<template>
   <view-coachup
       :coachup="coachup"
       v-if="coachup"
       :show-x="false"
       :show-print="false"
       :compact="true"
   ></view-coachup>
</template>





<script>

   import viewCoachup from '../components/viewCoachup';
   import data_getters from '../mixins/data_getters'


   export default {
      name: 'ViewCoachUpContainer',
      components:{
         viewCoachup
      },
      mixins: [data_getters],
      data() {
         return {
            coachup: null,

            oldTitle: null,


         };
      },
      async created(){
         this.oldTitle = document.title;
         document.title = 'TaskTeacher Coachup';

         this.coachup  = await this.get_coachups({_id: this.$route.params.coachup_id});
         console.log(this.coachup)
         // this.coachup = tmp[0];
         setTimeout(()=>{
            window.print()
         }, 1000)
      },

      beforeDestroy() {
         document.title = this.oldTitle;
      }

   };
</script>
